export const CREATE_FINE_HISTORY = "CREATE_FINE_HISTORY";
export const FETCH_FINE_HISTORIES = "FETCH_FINE_HISTORIES";
export const FETCH_FINE_HISTORY = "FETCH_FINE_HISTORY";
export const EDIT_FINE_HISTORY = "EDIT_FINE_HISTORY";
export const DELETE_FINE_HISTORY = "DELETE_FINE_HISTORY";
